import {
    LocationsContainer,
    LocationsBox,
    LocationsTitle,
    LocationsDescription,
    LocationsButton,
    LocationsCards,
    LocationsContent,
    LocationsCardTitle,
    LocationsAddress,
    LocationsNumber,
    LocationsImage,
} from './styled';
import eastCost from 'assets/images/east-coast.png';
import westCost from 'assets/images/west-coast.png';
import { NavLink } from 'react-router-dom';

interface LocationsProps {
    isWeHaveToShowYou: boolean;
}

function Locations({ isWeHaveToShowYou }: LocationsProps) {
    const data = [
        {
            location: 'East Coast',
            address: '125 Little Conestoga Road, Chester Springs, PA 19425',
            phoneNumber: '(877) 208-7308',
            phoneURl:'tel:8772087308',
            image: eastCost,
            alt: 'east-cost',
        },
        {
            location: 'West Coast ',
            address: '10600 Shoemaker Ave, Unit C, Santa Fe Springs, CA 90670',
            phoneNumber: '(877) 208-7308',
            phoneURl:'tel:8772087308',
            image: westCost,
            alt: 'west-coast',
        },
    ];

    return (
        <LocationsContainer className="container">
            {isWeHaveToShowYou ? (
                <LocationsBox>
                    <LocationsTitle>We Have So Much To Show You</LocationsTitle>
                    <LocationsDescription>
                        We would love to show you around our Profound Experience Center
                    </LocationsDescription>
                    <NavLink
                        to="https://meetings.hubspot.com/darla-zang/experience-center-demo"
                        target="_blank"
                    >
                        <LocationsButton>
                            Schedule an appointment today!
                        </LocationsButton>
                    </NavLink>
                </LocationsBox>
            ) : null}
            <LocationsCards>
                {data.map((item, index) => (
                    <LocationsContent key={index}>
                        <LocationsCardTitle>{item.location}</LocationsCardTitle>
                        <LocationsAddress>{item.address}</LocationsAddress>
                        <LocationsNumber href={item.phoneURl}>{item.phoneNumber}</LocationsNumber>
                        <LocationsImage
                            src={item.image}
                            alt={item.alt}
                            loading="lazy"
                            width="430"
                            height="250"
                        />
                    </LocationsContent>
                ))}
            </LocationsCards>
        </LocationsContainer>
    );
}

export default Locations;
